// C1: Room 列表变更总线 —— useRoom / Dialog / 右键菜单改完 storage 后
// 调 notifyRoomsChanged()，RoomList 订阅 "change" 事件后 listRooms() 刷新。

const bus = new EventTarget();
const CHANGE = "change";

export function onRoomsChanged(handler: () => void): () => void {
  bus.addEventListener(CHANGE, handler);
  return () => bus.removeEventListener(CHANGE, handler);
}

export function notifyRoomsChanged(): void {
  bus.dispatchEvent(new Event(CHANGE));
}
